module.exports = __webpack_public_path__ + "static/img/10.355eb0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/10.png
// module id = aq05
// module chunks = 0